// extracted by mini-css-extract-plugin
module.exports = {"container":"AnnotationsTemplate_container__cFmSQ","list":"AnnotationsTemplate_list__foXxM","listItem":"AnnotationsTemplate_listItem__1Llug"};